import { BuilderComponentGroup } from '../types'

export const ProfileDesignBlocks: BuilderComponentGroup = {
  id: 'profile',
  title: 'Profile',
  components: [
    {
      compId: 'profile-1',
      title: 'Profile 1',
      icon: 'Profile1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'profile-2',
      title: 'Profile 2',
      icon: 'Profile2',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    // {
    //   compId: 'profile-3',
    //   title: 'Profile 3',
    //   icon: 'Profile3',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
  ],
}
